document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector("#Slider-Gallery-template .slides");
  const slides = document.querySelectorAll("#Slider-Gallery-template .slider__slide");
  const prevBtn = document.querySelector("#Slider-Gallery-template .prev");
  const nextBtn = document.querySelector("#Slider-Gallery-template .next");
  const indicatorsContainer = document.querySelector("#Slider-Gallery-template .indicators");
  
  let currentIndex = 0;
  const totalSlides = slides.length;

  function updateSlider() {
    slider.style.transform = `translateX(-${currentIndex * 100}%)`;
    indicatorsContainer.querySelectorAll('div').forEach((indicator, index) => {
      indicator.classList.toggle('active', index === currentIndex);
    });
  }

  function showNextSlide() {
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlider();
  }

  function showPrevSlide() {
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    updateSlider();
  }

  function goToSlide(index) {
    currentIndex = index;
    updateSlider();
  }

  // Button events
  nextBtn.addEventListener('click', showNextSlide);
  prevBtn.addEventListener('click', showPrevSlide);

  // Indicator click events
  indicatorsContainer.querySelectorAll('div').forEach((indicator, index) => {
    indicator.addEventListener('click', () => goToSlide(index));
  });

  // Autoplay with pause on hover
  let autoplay = setInterval(showNextSlide, 5000);

  slider.addEventListener('mouseenter', () => {
    clearInterval(autoplay);
  });

  slider.addEventListener('mouseleave', () => {
    autoplay = setInterval(showNextSlide, 5000);
  });
});
